<template>
  <div class="container">
    <div
      class="fileslist"
    >
      <Headline
        v-if="resource.columns.title"
        v-editable="resource.columns.title"
        :size="2"
        class="fileslist__title"
      />
      <div
        class="fileslist__downloads"
      >
        <div
          v-for="file in resource.files"
          :key="file.id"
          class="fileslist__download"
        >
          <span class="fileslist__file-title">
            {{ file.readableName }}
          </span>
          <span class="fileslist__meta">
            {{ displaySize(file.columns.file.byte_size) }}
            {{ displayMediaType(file.columns.file.content_type) }}
          </span>
          <span class="fileslist__container">
            <a
              :href="file.columns.file.url"
              target="_blank"
              download
            >
              <DownloadIcon class="fileslist__icon" />
              <ImageEmpty
                :image-title="file.readableName"
              />
            </a>
          </span>
        </div>
        <div v-if="!resource.files.length">
          Keine Downloads.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DownloadIcon from 'beisheim/assets/images/icons/beisheim-stiftung-download.svg'
import editable from '@i22/frontend-cms-utils/mixins/editable'
import Headline from 'beisheim/components/elements/headline'
import ImageEmpty from 'beisheim/components/elements/image-empty'

function formatWithSingleDigitFraction (number) {
  const intVal = Math.floor(number)
  const fracVal = Math.round((number * 10) % 10)
  if (fracVal > 0) {
    return `${intVal},${fracVal}`
  }
  return `${intVal}`
}

export default {
  components: {
    Headline,
    DownloadIcon,
    ImageEmpty
  },
  mixins: [ editable ],
  methods: {
    displaySize (size) {
      if (typeof size !== 'number') {
        return ''
      }
      if (size < 1024) {
        return `${size} Bytes,`
      }
      if (size < 1024 * 1024) {
        return `${formatWithSingleDigitFraction(size / 1024)} KB,`
      }
      return `${formatWithSingleDigitFraction(size / (1024 * 1024))} MB,`
    },
    displayMediaType (contentType) {
      const ext = contentType.split('/')[1]
      return ext.toUpperCase()
    }
  }
}
</script>

<style lang="scss">
  @import '~beisheim/scss/colors';
  @import '~beisheim/scss/scale';
  @import '~beisheim/scss/zindex';
  @import '~beisheim/scss/font';
  @import '~beisheim/scss/breakpoints';
  @import '~beisheim/scss/grid';

  .fileslist {
    margin: scale(20) auto;

    @include from(4) {
      display: flex;
      justify-content: space-between;
    }

    &__title {
        @include font(2);
        flex: 1;
        margin-bottom: scale(8);
        padding-right: scale(8);
    }

    .fileslist__icon {
      display: block;
      width: 35px;
    }

    &__downloads {
      flex: 1;

      @include from(6) {
        min-width: 65%;
      }
    }

    &__download {
      padding: scale(6);
      padding-right: scale(18);
      border-top: 1px solid #D8D8D8;
      display: flex;
      justify-content: space-between;
      position: relative;
      transition: background-color 200ms ease-in-out;
      flex-direction: column;

      @include from(6) {
        flex-direction: row;
      }

      &:hover {
        background-color: gray(4);
      }

      .fileslist__container {
        position: absolute;
        right: scale(6);
        top: 50%;
        transform: translateY(-50%);
      }

      .fileslist__file-title {
        width: 70%;
        display: inline-block;
      }

      .fileslist__meta {
        @include font(-1);
        margin-top: 5px;
      }

      &:last-child {
        border-bottom: 1px solid #D8D8D8;
      }

    }
  }
</style>
